export default __webpack_public_path__ + "static/Poppins-MediumItalic-d800211f40584510d941cdfacbb94584.woff2";